<template>
  <data-list
    ref="dataList"
    class="content"
    url="/activity/activity-vehicle-journey"
    entity-name="行程"
    add-btn="新增行程"
    hide-edit
    hide-delete
    :custom-update="customUpdate"
    :modal-width="640"
    :modal-form="modalForm"
    :query="query"
    :action="action"
    :columns="columns"
    :rules="rules"
    @detail="showDetail"
    v-if="activity">
    <template v-slot:query="{form}">
      <a-form-model-item label="">
        <a-select
          placeholder="选择车辆筛选"
          @change="updateList"
          :options="vehicleList"
          v-model="form.vehicle_id"
          style="width: 180px">
        </a-select>
      </a-form-model-item>
    </template>
    <template v-slot:action="{item}" v-if="editable">
      <a class="txt-btn" @click="cancelJourney(item)">取消派车</a>
    </template>
    <template v-slot:edit="{form}">
      <a-form-model-item label="车辆" prop="vehicle">
        <select-entity
          v-model="form.vehicle"
          btn-text="选择车辆"
          url="/activity/activity-vehicle"
          :modal-width="1000"
          :query="`&expand=leftSeats&filter[activity_id]=${activity.id}`"
          :columns="vehicleColumns">
          <template v-slot:item="{item}">
            <div class="entity-name">{{`${getVehicleTypeText(item.car_type)}-${item.car_number}`}}</div>
          </template>
        </select-entity>
      </a-form-model-item>
      <a-form-model-item label="派车时间" prop="time">
        <a-range-picker
          v-model="form.time"
          :placeholder="['开始时间', '结束时间']"
          :show-time="{format: 'HH:mm'}"
          format="YYYY-MM-DD HH:mm"
          value-format="YYYY-MM-DD HH:mm"/>
      </a-form-model-item>
      <a-form-model-item label="嘉宾/随行人员" prop="guest">
        <select-person v-model="form.guest" guest multiple :activity="activity.id"></select-person>
      </a-form-model-item>
      <a-form-model-item label="陪同人员">
        <select-person v-model="form.receptionist" multiple :type="3" :activity="activity.id"></select-person>
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>
    import {vehicleColumns} from "../../../common/activity/vehicle";
    import {getDate} from "../../../common/js/tool";
    import {getVehicleTypeText} from "../../../common/activity/vehicle";
    import mixins from "../mixins";

    export default {
        name: "VehicleAssign",
        data() {
            return {
                loading: false,
                list: [],
                form: {},
                h: 500,
                columns: [
                    {title: '派车时间', dataIndex: 'start_time', customRender: (text, record) => `${getDate(text).pattern("yyyy-MM-dd HH:mm")} - ${getDate(record.end_time).pattern("yyyy-MM-dd HH:mm")}`},
                    {title: '车牌号', dataIndex: 'vehicle',  customRender: text => text ? text.car_number : '--'},
                    {title: '车辆类型', dataIndex: 'car_type',  customRender: (text, record) => record.vehicle ? getVehicleTypeText(record.vehicle.car_type) : '--'},
                    {title: '座位数', dataIndex: 'seats',  customRender: (text, record) => record.vehicle ? `${(record.receptionist || []).length + (record.vehicleAllocation || []).length + 1}/${record.vehicle.seats}` : '--'},
                    {title: '司机姓名', dataIndex: 'driver_name',  customRender: (text, record) => record.driver && record.driver ? record.driver.name : '--'},
                    {title: '手机号', dataIndex: 'driver_tel',  customRender: (text, record) => record.driver && record.driver ? record.driver.tel : '--'},
                ],
                rules: {
                    vehicle: [{ required: true, message: '请选择车辆', trigger: 'change' }],
                    time: [{ required: true, message: '请选择派车时间', trigger: 'change' }],
                    guest: [{ required: true, message: '请选择嘉宾/随行人员', trigger: 'change' }],
                    receptionist: [{ required: true, message: '请选择陪同人员', trigger: 'change' }],
                },
                vehicleColumns,
                pagination: {
                    total: 0,
                    current: 1,
                    pageSize: 10,
                    showSizeChanger: true
                },
                vehicleList: [{key: 0, title: '所有车辆'}],
                guest: null,
                meal: null,
                visible: false,
                modalForm: {
                    labelAlign: 'left',
                    labelCol: {span: 6},
                    wrapperCol: {span: 18}
                },
                moduleKey: 'traffic-assign',
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '&expand=vehicleAllocation,receptionist,vehicle,driver';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        watch: {
            activity() {
                this.getVehicleList();
            }
        },
        created() {
            this.getVehicleList();
        },
        methods: {
            getVehicleTypeText,
            showDetail({item}) {
                this.$router.push({name: 'ActivityJourney', params: {id: item.activity_id, journey: item.id}});
            },
            cancelJourney(item) {
                this.$confirm({
                    title: "提示",
                    content: '确定取消此行程吗？',
                    onOk: () => {
                        let url = `/activity/activity-vehicle-journey/${item.id}`;
                        this.$axios({
                            url,
                            method: "DELETE",
                        }).then(() => {
                            this.$message.success("已取消");
                            this.updateList();
                        });
                    },
                    onCancel: () => {},
                });
            },
            customUpdate(form, index, fn) {
                const url = '/activity/activity-vehicle-allocation/add-guest';
                const data = {
                    activity_id: this.activity.id,
                    vehicle_id: form.vehicle.id,
                    guest_id: form.guest.map(s => s.id).join(","),
                    receptionist_id: form.receptionist && form.receptionist.length > 0 ? form.receptionist.map(s => s.id).join(",") : null,
                    delivery_start_time: form.time[0],
                    delivery_end_time: form.time[1]
                }
                this.$axios({
                    url,
                    method: 'POST',
                    data
                }).then(res => {
                    if(res.error == 0) {
                        fn();
                    } else {
                        this.$message.warning(res.msg || '添加失败');
                    }
                })
            },
            getVehicleList() {
                const activity = this.activity;
                if(!activity) return;
                const url = `/activity/activity-vehicle?pageSize=1000&filter[activity_id]=${activity.id}`;
                this.$axios(url).then(res => {
                    const list = res.data.map(item => new Object({key: item.id, title: `${getVehicleTypeText(item.car_type)}-${item.car_number}`}))
                    this.vehicleList.push(...list)
                });
            },
            assignPerson(record) {
                record.detailList = [
                    {label: '酒店名称', value: record.hotel_name},
                    {label: '酒店地址', value: record.hotel_address},
                    {label: '用餐地点', value: record.dining_place},
                    {label: '用餐类型', value: record.dining_type},
                    {label: '用餐时间', value: `${getDate(record.dinner_start_time).pattern("yyyy-MM-dd HH:mm")} 至 ${getDate(record.dinner_end_time).pattern("yyyy-MM-dd HH:mm")}`},
                ]
                this.meal = record;
                this.visible = true;
            },
            updateList() {
                this.$refs.dataList.getList();
            },
        }
    }
</script>

<style scoped>

</style>
